import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../modal';
import RequestError from './request-error';

const propTypes = {
	shouldClose: PropTypes.bool
};

const defaultProps = {
	shouldClose: false
};

class RequestErrorModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: true
		};
	}

	close() {
		this.setState({ isOpen: false });
	}

	render() {
		const Body = <RequestError {...this.props} close={this.close.bind(this)} />;
		return <Modal
			isOpen={this.state.isOpen}
			body={Body}
			onClose={this.props.shouldClose ? this.close.bind(this) : null} />;
	}
}

RequestErrorModal.propTypes = propTypes;
RequestErrorModal.defaultProps = defaultProps;

export default RequestErrorModal;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/errors/request-error-modal.js